
import { MenuItem, ListItemText, ListItemIcon } from '@mui/material'
import { Edit3 } from 'react-feather'

import {
    CustomTableData,
    CustomDropDown,
    TooltipInformation,
    TooltipApprovalInfo
} from 'common'

export const AppliesTable = ({useFetchInit}) => {

    const {
        FetchData,
        Actions
    }= useFetchInit

    const { fetchAllLeaseApplications } = FetchData
    const { leaseApplications } = fetchAllLeaseApplications


    const { handleClickEditLease } = Actions
    

    const columnConfig = [
        { 
            //FIELD PARA TOOLTIP
            headerName: "Info",
            maxWidth: 80,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellRenderer: (params) => {
                    //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                    const {idcontrato, usuario_creo, fecha_creo, usuario_modifico, fecha_modifico} = params.data
                    return(
                        <>
                            <TooltipInformation
                                idregistro={idcontrato}
                                usuario_creo={usuario_creo}
                                fecha_creo={fecha_creo}
                                usuario_modifico={usuario_modifico}
                                fecha_modifico={fecha_modifico}
                            />
                        </>
                        
                    )
            }
        },
        { field: "contrato_fecha", headerName: "FECHA", minWidth: 150, filter: true },
        { field: "contrato_codigo", headerName: "IDENTIFICADOR", minWidth: 200, filter: true },
        { field: "descripcion_casa", headerName: "DESCRIPCION DE LA CASA", minWidth: 250, filter: true },
        { field: "datos_cliente", headerName: "DATOS DEL CLIENTE", minWidth: 280, filter: true },
        { field: "plazo_meses", headerName: "PLAZO", minWidth: 150, filter: true },
        { 
            field: "contrato_costo_alquiler", headerName: "ALQUILER (Q)", minWidth: 150, filter: true,
            cellRenderer: (params) => 'Q ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        { 
            field: "aprobacion_check",
            headerName: "APROBACION",
            minWidth: 250,
            maxWidth: 250,
            filter: true,
            cellStyle: (params) => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellClass: (params) => {

                if(params.value === 'PENDIENTE APROBACION') return 'bg-warning';
                if(params.value === 'PENDIENTE CONTRATO') return 'bg-warning';
                if(params.value === 'DEVUELTO A JURIDICO') return 'bg-danger';
                if(params.value === 'RECHAZADO') return 'bg-danger';

            },
            cellRenderer: (params) => {
                const { value } = params
                const { aprobacion_usuario, aprobacion_fecha } = params.data

                if(value === 'PENDIENTE APROBACION') return (
                    <TooltipApprovalInfo
                        texto_approval='PENDIENTE APROBACION'
                        usuario_approval={aprobacion_usuario}
                        fecha_approval={aprobacion_fecha}
                    />
                );

                if(value === 'PENDIENTE CONTRATO') return (
                    <TooltipApprovalInfo
                        texto_approval='PENDIENTE CONTRATO'
                        usuario_approval={aprobacion_usuario}
                        fecha_approval={aprobacion_fecha}
                    />
                );

                if(value === 'RECHAZADO') return (
                    <TooltipApprovalInfo
                        texto_approval='RECHAZADO'
                        usuario_approval={aprobacion_usuario}
                        fecha_approval={aprobacion_fecha}
                    />
                );

                if(value === 'DEVUELTO A JURIDICO') return (
                    <TooltipApprovalInfo
                        texto_approval='DEVUELTO A JURIDICO'
                        usuario_approval={aprobacion_usuario}
                        fecha_approval={aprobacion_fecha}
                    />
                );

            }
        },
        {
            headerName: "OPCIONES",
            minWidth: 200,
            cellRenderer: (params) => {
                const {idcontrato} = params.data

                return (
                    <CustomDropDown>
                        <MenuItem
                            onClick={() => handleClickEditLease(idcontrato)}
                        >
                            <ListItemIcon> <Edit3 color="black"/> </ListItemIcon>
                            <ListItemText primary="Responder" />
                        </MenuItem>
                    </CustomDropDown>
                )
            }
        },
    ]

    return (
        <div className='content'>
            <CustomTableData 
                rowConfig={leaseApplications}
                columnConfig={columnConfig}
            />
        </div>
    )
}